import XEUtils from 'xe-utils'

export default {
	fmDateTime(e) {
		// 使用正则表达式匹配时间格式，并保留最多三位小数
		if (e) {
			let timestr = e.replace(/(\.\d{3})\d*/, '$1')
			return XEUtils.toDateString(timestr, 'yyyy-MM-dd HH:mm:ss')
		} else {
			return ''
		}
	}
}
